//
// Action types
//

export const SET_MAP_DRAGGED_CONTRIBUTION = "SET_MAP_DRAGGED_CONTRIBUTION";
export const UNSET_MAP_DRAGGED_CONTRIBUTION = "UNSET_MAP_DRAGGED_CONTRIBUTION";

export const ENABLE_MAP_CONTRIBUTION_CREATION = "ENABLE_MAP_CONTRIBUTION_CREATION";
export const DISABLE_MAP_CONTRIBUTION_CREATION_LOCATION =
  "DISABLE_MAP_CONTRIBUTION_CREATION_LOCATION";
export const DISABLE_MAP_CONTRIBUTION_CREATION = "DISABLE_MAP_CONTRIBUTION_CREATION";

export const ADD_MAP_CONTRIBUTION = "ADD_MAP_CONTRIBUTION";
export const CONSUME_MAP_CONTRIBUTION = "CONSUME_MAP_CONTRIBUTION";
export const CANCEL_MAP_CONTRIBUTION_CREATION = "CANCEL_MAP_CONTRIBUTION_CREATION";

//
// Action creators
//

export function setMapDraggedContribution(mapKey) {
  return {
    type: SET_MAP_DRAGGED_CONTRIBUTION,
    mapKey
  };
}

export function unsetMapDraggedContribution(mapKey) {
  return {
    type: UNSET_MAP_DRAGGED_CONTRIBUTION,
    mapKey
  };
}

export function enableMapContributionCreation(mapKey) {
  return {
    type: ENABLE_MAP_CONTRIBUTION_CREATION,
    mapKey
  };
}

export function disableMapContributionCreationLocation(mapKey) {
  return {
    type: DISABLE_MAP_CONTRIBUTION_CREATION_LOCATION,
    mapKey
  };
}

export function disableMapContributionCreation(mapKey) {
  return {
    type: DISABLE_MAP_CONTRIBUTION_CREATION,
    mapKey
  };
}

export function addMapContribution(mapKey, data = {}) {
  return {
    type: ADD_MAP_CONTRIBUTION,
    mapKey,
    data
  };
}

export function consumeMapContribution(mapKey) {
  return {
    type: CONSUME_MAP_CONTRIBUTION,
    mapKey
  };
}

function addMapContributionHandler(state, data) {
  const { lat, lng, droppableZoneId, explicitlyGeolocated } = data;
  const latLng = lat && lng && { lat, lng };
  // The `consumed` property of the newContribution object allows contribution form modals
  // to consume the latitude and longitude of the dropped contribution on the map before
  // initializing the new contribution.
  const consumed = false;

  return {
    ...state,
    newContribution: { latLng, droppableZoneId, consumed, explicitlyGeolocated }
  };
}

function consumeMapContributionHandler(state) {
  if (!state.newContribution) return state;

  const { newContribution } = state;
  return { ...state, newContribution: { ...newContribution, consumed: false } };
}

function setMapDraggedContributionHandler(state) {
  return { ...state, draggedContribution: true };
}

function unsetMapDraggedContributionHandler(state) {
  return { ...state, draggedContribution: false };
}

function enableMapContributionCreationHandler(state) {
  return { ...state, contributionCreation: { allowLocation: true } };
}

function disableMapContributionCreationLocationHandler(state) {
  if (!state.contributionCreation) return state;

  const newState = { ...state };

  newState.contributionCreation.allowLocation = false;

  return newState;
}

function disableMapContributionCreationHandler(state) {
  const newState = { ...state };

  if (newState.contributionCreation) delete newState.contributionCreation;
  if (newState.newContribution) delete newState.newContribution;

  return newState;
}

//
// Reducer and handlers
//

export function reduceMapContribution(state, action) {
  switch (action && action.type) {
    case SET_MAP_DRAGGED_CONTRIBUTION:
      return setMapDraggedContributionHandler(state);

    case UNSET_MAP_DRAGGED_CONTRIBUTION:
      return unsetMapDraggedContributionHandler(state);

    case ENABLE_MAP_CONTRIBUTION_CREATION:
      return enableMapContributionCreationHandler(state);

    case DISABLE_MAP_CONTRIBUTION_CREATION_LOCATION:
      return disableMapContributionCreationLocationHandler(state);

    case DISABLE_MAP_CONTRIBUTION_CREATION:
      return disableMapContributionCreationHandler(state);

    case ADD_MAP_CONTRIBUTION:
      return addMapContributionHandler(state, action.data);

    case CONSUME_MAP_CONTRIBUTION:
      return consumeMapContributionHandler(state);

    default:
      return state || {};
  }
}
